import {Injectable} from '@angular/core';
import {App} from "@capacitor/app";
import {Network} from "@capacitor/network";
import {AppUpdatesInfo} from "../../types/apiResponse.interface";
import {AppUpdatesComponent} from "../../shared/components/modals/app-updates/app-updates.component";
import {ModalController, Platform} from "@ionic/angular";
import {APP_VERSION} from "../../../providers/config";


@Injectable({
    providedIn: 'root'
})
export class AppInfoService {
    versionCode: string  = APP_VERSION;
    connectionType: string = 'unknown';

    constructor( private modalCtrl: ModalController,private platform: Platform) {
    }

    public async initApp() {
        if (this.platform.is('hybrid')) {
            await this.loadAppInfo();
            await this.checkConnection();
        }
    }

    public async loadAppInfo(): Promise<void> {
        const info = await App.getInfo();

        this.versionCode = info.version;
    }

    public getVersionCode(): string | null {
        return this.versionCode;
    }

    public async checkConnection(): Promise<void> {
        const status = await Network.getStatus();
        this.connectionType = status.connectionType;
    }

    public getConnectionType(): string {
        if (this.connectionType != 'unknown') {
            return this.connectionType
        } else {
            let connection = (navigator as any).connection;
            return connection?.effectiveType || 'unknown';
        }
    }

    async openAppUpdates(appInfo: AppUpdatesInfo) {
        let modal = await this.modalCtrl.create({
            component: AppUpdatesComponent,
            cssClass: 'auto-height app-updates-modal',
            backdropDismiss: !appInfo.isMandatory,
            canDismiss: !appInfo.isMandatory,
            componentProps: {
                title: appInfo.title,
                messageNowBtn: appInfo.messageOk,
                messageAfterBtn: appInfo.messageAfter,
                isMandatory: appInfo.isMandatory
            }
        });

        await modal.present();
    }
}
